import { createContext } from "react";

import { GoalsContextState } from "./types";

export const GoalsContext = createContext<GoalsContextState>({} as GoalsContextState);
